
import StageManager from "../../../../../shared/lib/html5-software-library/src/ranj/performance/StageManager";
import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import { applySearchParametersToObject, getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
/////////////
import { generateLevel } from "../model/LevelGenerator";
import RoadBuilder from "../view/RoadBuilder";
//////////

export default class InitFlexGameTask extends Task {

    /**
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     * @param {GameModel} gameModel 
     * @param {StageManager} stageManager
     * @param {RoadBuilder} roadBuilder
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameModel, stageManager, roadBuilder) {
        super();

        this.execute = function(callback, progressCallback) {

            if (AppModel.isMobile) {
                stageManager.setAllStagesFramerate(30);
            }

            var configJSON = assetLibrary.getAsset("gameConfig");
            if (ranj.DEBUG) {
                applySearchParametersToObject(window.top.location.search, configJSON);
                window.document.addEventListener("keyup", this._handleKeyUp);
            }
            gameConfig.setPropertiesFromObject(configJSON);

            gameModel.initialize();

/////////////////////////
            if (ranj.DEBUG) {
                window.gameconfig = gameConfig;
                window.gamemodel = gameModel;

                if (getURLParameter("generate") == "1") {
                    generateLevel();
                }
            }
//////////////////////

            roadBuilder.initialize();

            callback(this);
        }

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            }
        }.bind(this);
    }


}

